/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Help_ContactInputs */



/**
* | output |
* | --- |
* | "Didn't find your answer? Contact your oneAI partner manager — we are happy to help." |
*
* @param {Partner_Help_ContactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_help_contact = /** @type {((inputs?: Partner_Help_ContactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Help_ContactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Antwort gefunden? Wenden Sie sich an Ihren oneAI-Partnermanager — wir helfen gerne.")
	return /** @type {LocalizedString} */ ("Didn't find your answer? Contact your oneAI partner manager — we are happy to help.")
});